import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: true,
  selector: 'dcc-share-link-button',
  templateUrl: './share-link-button.component.html',
  styleUrls: ['../buttons.scss', './share-link-button.component.scss'],
})
export class ShareLinkButtonComponent {
  @Input() disabled = false;

  constructor(private toastr: ToastrService) {}

  shareLink() {
    navigator.clipboard.writeText(window.location.href);
    this.toastr.info('Copied link to your clipboard.');
  }
}
